import {Component} from '@angular/core';
import {InsightsPanelComponent} from './insights-panel/insights-panel.component';

@Component({
    selector: 'app-disinfection',
    standalone: true,
    imports: [InsightsPanelComponent],
    templateUrl: './disinfection.component.html',
    styleUrl: './disinfection.component.scss'
})
export class DisinfectionComponent {}
